import type { InputTextDesignTokens } from '@primeuix/themes/types/inputtext';

export const inputTextPreset: InputTextDesignTokens = {
  root: {
    borderRadius: '{borderRadius}',
    paddingX: '8px',
    paddingY: '7px',
  },
  colorScheme: {
    dark: {
      root: {
        background: '{nspSlate.800}',
        borderColor: '{nspSlate.200}',
        hoverBorderColor: '{nspSlate.200}',
        focusBorderColor: '{nspSky.300}',
        invalidBorderColor: '{formField.invalidBorderColor}',
        color: '{nspSlate.0}',
        disabledColor: '{nspSlate.100}',
        disabledBackground: '{nspSlate.700}',
        placeholderColor: '{nspSlate.100}',
      },
    },
    light: {
      root: {
        background: '{nspSlate.0}',
        borderColor: '{nspMist.300}',
        hoverBorderColor: '{nspMist.300}',
        focusBorderColor: '{nspSky.300}',
        invalidBorderColor: '{formField.invalidBorderColor}',
        color: '{nspMist.900}',
        disabledColor: '{nspMist.400}',
        placeholderColor: '{nspMist.400}',
      },
    },
  },
};
